import { CardHistoryTabs } from "@/modules/card/common/enum";
import { getCardHistoryTabItems } from "@/modules/card/helpers";
import { Heading } from "@ab.uitools/ui-library/components/Heading";
import { Tab } from "@ab.uitools/ui-library/components/Tab";
import { type ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";

import { CardOnlineTransactionsHistory } from "./CardOnlineTransactions";
import { CardTransactionsHistory } from "./CardTransactionsHistory";

type ITemplate = {
  [key in CardHistoryTabs]: ReactNode;
}

export const CardHistory = () => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState<CardHistoryTabs>(CardHistoryTabs.Transactions);

  const onTabChange = (value: string) => {
    setSelectedTab(value as CardHistoryTabs);
  };

  const template: ITemplate = {
    [CardHistoryTabs.Transactions]: <CardTransactionsHistory/>,
    [CardHistoryTabs.OnlineTransactions]: <CardOnlineTransactionsHistory/>,
  };

  return (
    <div className="position-relative page-body">
      <div className="full-width flexbox justify-content--center">
        <div className="advanced_table-wrapper table-with-tab">
          <div className="full-width pb-24">
            <Heading className="content-title" weight="bolder" size="xsmall">
              {t("cards.cardHistory")}
            </Heading>
          </div>
          <div
            className="flexbox justify-content--between align-items--center full-width tabs-section mb-16">
            <Tab
              size="small"
              color="light"
              tabItems={getCardHistoryTabItems({ t })}
              selectedValue={selectedTab}
              onSelect={(value) => onTabChange(value as string)}
            />
          </div>
          {template[selectedTab]}
        </div>
      </div>
    </div>
  );
};
